<main class="container-fluid">
  <div class="row row-eq-height">
    <section class="col-8">
      <div class="lesson-content">
        <div class="problem-content sticky-top">
          <p>A steel-copper bimetallic strip is prepared with a length of 10 cm and a thickness of 1.2 mm. Based on the results of Trials 1 and 11–13, if this strip were subjected to a temperature change of 10 °C, which of the following deflection values would be the most likely result?</p>

          <div id="problemHint" [ngbCollapse]="hintCollapsed">
            <div class="card">
              <div class="card-body">
                Explanation. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed ut convallis libero, eu ultrices quam. Quisque vitae purus non urna sollicitudin ultrices in nec est.
              </div>
            </div>
          </div>
        </div>

        <div class="problem-passage">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed ut convallis libero, eu ultrices quam. Quisque vitae purus non urna sollicitudin ultrices in nec est. Nunc rutrum ligula semper turpis eleifend pretium. Sed et sollicitudin ex. Nam posuere metus diam, ac vestibulum nisi eleifend sed. Integer vel condimentum arcu. Proin viverra nisl eget elit tempus semper.

          In faucibus suscipit mi quis aliquet. Etiam eget ligula sed felis ullamcorper condimentum imperdiet vitae lorem. Aenean a elit diam. Mauris hendrerit imperdiet magna, vel semper dolor lobortis at. In pellentesque nisl id quam posuere, in convallis orci ultrices. Integer imperdiet sodales sapien, sit amet placerat velit commodo sed. Curabitur quis felis sit amet tortor vulputate gravida. Nam dapibus rutrum nulla eget hendrerit. Nam mollis interdum arcu sit amet aliquet. Proin nec urna a quam eleifend bibendum non a dui. Suspendisse varius magna ex, eu scelerisque neque rhoncus et.

          Etiam at ipsum non purus accumsan scelerisque. Vestibulum mattis libero vitae lectus vulputate imperdiet. Donec enim augue, luctus ut quam non, pellentesque aliquam ligula. Fusce accumsan nisl id purus bibendum, et vulputate dolor tincidunt. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Quisque vehicula volutpat massa nec ultrices. Morbi auctor tortor mi, eget consequat augue porta vel. In cursus blandit lectus.

          Vestibulum sit amet auctor velit. Quisque quis sem mattis odio commodo interdum. Vestibulum pharetra posuere lorem sit amet vulputate. Duis a ornare orci, sed scelerisque nulla. Vivamus malesuada, augue quis luctus commodo, sem metus dapibus libero, a auctor ligula dui dignissim sapien. Maecenas varius bibendum elementum. Nullam elementum feugiat sem et efficitur. Aliquam lacus erat, egestas ut tristique sed, cursus et magna.

          Mauris posuere felis ipsum, et tempus ante ornare at. Praesent blandit condimentum nibh, eget elementum augue cursus a. Vivamus id aliquet eros. Sed imperdiet aliquam fringilla. Maecenas cursus, risus sit amet bibendum porttitor, neque enim aliquet nisi, vitae dictum erat sem at enim. Donec bibendum mauris nec odio bibendum, quis commodo libero lacinia. In lobortis purus in libero pulvinar dapibus. Duis pellentesque molestie finibus. Vivamus libero ligula, faucibus in nunc sed, cursus laoreet velit. Donec sit amet maximus nisi. Pellentesque quis euismod lorem.
        </div>
      </div>

      <div class="lesson-footer">
        <div class="lesson-goals">
          <div class="row">
            <div class="col-1 text-right">
              <i class="fa fa-bullseye"></i>
            </div>

            <div class="col-4">
              <div class="progress">
                <div class="progress-bar progress-bar-striped" role="progressbar"
                     style="height: 1.5rem; line-height: 1.5rem" aria-valuenow="20" aria-valuemin="0"
                     [style.width.%]="75"
                     aria-valuemax="100">75%
                </div>
              </div>
            </div>

            <div class="col-2 text-right">
              <i class="fa fa-stopwatch"></i> ##s
            </div>

            <div class="col-4">
              <div class="progress">
                <div class="w-50">
                  <div class="progress-bar progress-bar-striped bg-primary progress-bar-fast" role="progressbar"
                       [style.width.%]="25"
                       aria-valuenow="0"
                       aria-valuemin="0"
                       aria-valuemax="50">
                  </div>
                </div>
                <div class="w-50">
                  <div class="progress-bar progress-bar-striped bg-danger progress-bar-slow" role="progressbar"
                       [style.width.%]="0"
                       aria-valuenow="0"
                       aria-valuemin="0"
                       aria-valuemax="50">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <aside class="col-4">
      <div class="lesson-answers">
        <h4>Prompt Headline</h4>

        <button class="btn btn-primary btn-answer" [routerLink]="['/exercise/complete']">Answer</button>
        <button class="btn btn-primary btn-answer" [routerLink]="['/exercise/complete']">Answer</button>
        <button class="btn btn-primary btn-answer" [routerLink]="['/exercise/complete']">Answer</button>
        <button class="btn btn-primary btn-answer" [routerLink]="['/exercise/complete']">Answer</button>
      </div>

      <hr>

      <div class="lesson-smartsavers">
        <button class="btn btn-primary btn-sm">
          Pause
          <span class="badge badge-pill badge-light">#</span>
        </button>

        <button class="btn btn-primary btn-sm"
                (click)="hintCollapsed = !hintCollapsed"
                [attr.aria-expanded]="!hintCollapsed"
                aria-controls="problemHint">
          Hint
          <span class="badge badge-pill badge-light">#</span>
        </button>

        <button class="btn btn-primary btn-sm">
          50/50
          <span class="badge badge-pill badge-light">#</span>
        </button>

        <button class="btn btn-primary btn-sm">
          Skip
          <span class="badge badge-pill badge-light">#</span>
        </button>
      </div>

      <hr>

      <div class="custom-control custom-checkbox">
        <input type="checkbox" class="custom-control-input" id="customCheck1">
        <label class="custom-control-label" for="customCheck1">
          <i class="fa fa-exclamation"></i>
          Flag For Review
        </label>
      </div>
    </aside>
  </div>
</main>

<app-lesson-help></app-lesson-help>
